module.exports = __webpack_public_path__ + "img/latte.0aac69c6.png";